import { Component, OnInit, ViewChild } from '@angular/core';

import { CommsTemplateComponent } from './comms-template.component';
import { CommsEventComponent } from './comms-event.component';
import { ICommsEvent } from '../../interfaces/comms-event';
import { CommsHistoryComponent } from './comms-history.component';

@Component({
  selector: 'comms-maintenance',
  styleUrls: ['./comms-maintenance.component.scss'],
  templateUrl: 'comms-maintenance.component.html',
})
export class CommsMaintenanceComponent implements OnInit {
  @ViewChild('comms-template') commsTemplate: CommsTemplateComponent;
  @ViewChild('comms-event') commsEvent: CommsEventComponent;
  @ViewChild('comms-history') commsHistory: CommsHistoryComponent;

  public commsEvents: ICommsEvent[];

  public tab = 0;

  constructor() {}

  async ngOnInit() {}

  changeTab($event: any) {
    console.log('EVENT ', $event);

    this.tab = $event.index;
  }
}
